export const MAP_STYLES: google.maps.MapTypeStyle[] = [
    { "featureType": "administrative.land_parcel", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "landscape.man_made", "elementType": "geometry.stroke", "stylers": [{ "color": "#e8ebf4" }, { "weight": 1 }] },
    { "featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "landscape.natural.landcover", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "landscape.natural.terrain", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "poi", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "poi", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "poi", "elementType": "geometry.stroke", "stylers": [{ "color": "#dbdbdb" }] },
    { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#68676a" }] },
    { "featureType": "poi.attraction", "stylers": [{ "color": "#68676a" }, { "visibility": "off" }] },
    { "featureType": "poi.attraction", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "poi.business", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "poi.business", "elementType": "labels.icon", "stylers": [{ "color": "#68676a" }] },
    { "featureType": "poi.government", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "poi.government", "elementType": "labels.icon", "stylers": [{ "color": "#696569" }] },
    { "featureType": "poi.medical", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "poi.medical", "elementType": "labels.icon", "stylers": [{ "color": "#6a696c" }] },
    { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "poi.park", "elementType": "labels.icon", "stylers": [{ "color": "#68676a" }] },
    { "featureType": "poi.place_of_worship", "stylers": [{ "visibility": "off" }] },
    { "featureType": "poi.place_of_worship", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "poi.school", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "poi.school", "elementType": "labels.icon", "stylers": [{ "color": "#696569" }] },
    { "featureType": "poi.sports_complex", "stylers": [{ "color": "#eae9ec" }] },
    { "featureType": "poi.sports_complex", "elementType": "geometry.fill", "stylers": [{ "color": "#f7f7f7" }] },
    { "featureType": "poi.sports_complex", "elementType": "labels.icon", "stylers": [{ "color": "#696569" }] },
    { "featureType": "road", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }] },
    { "featureType": "road", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] },
    { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#f2f8ff" }] },
    { "featureType": "transit", "stylers": [{ "visibility": "off" }] },
    { "featureType": "transit.line", "stylers": [{ "visibility": "off" }] },
    { "featureType": "transit.station", "stylers": [{ "visibility": "off" }] },
    { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#d2e6ff" }] }
    ,
    {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [
            { "visibility": "off" }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "labels",
        "stylers": [
            { "visibility": "off" }
        ]
    }
];


// WEBPACK FOOTER //
// ./src/constants/MapConsts.tsx